import { getAt } from '@finn-no/mobility-item-insertion-shared';
import { Toggle, type ToggleProps } from '@warp-ds/react';
import { Controller, type FieldError, useFormContext, useWatch } from 'react-hook-form';
import type { ToggleWidgetModel, ValueOption } from '../../../types/widget.js';
import { WidgetTypes } from '../../../types/widget-types.js';

interface ToggleWidgetProps extends ToggleWidgetModel {
  values: Array<ValueOption>;
}

type ToggleEntry = {
  label: React.ReactNode;
  value: unknown;
};

const ToggleWidget = ({ mandatory, type, ...rest }: ToggleWidgetProps & Omit<ToggleProps, 'type'>) => {
  return <Toggle {...rest} optional={!mandatory} type={type === WidgetTypes.RADIOGROUP ? 'radio' : 'checkbox'} />;
};

// TODO: Move this "Controlled" part out - it seems to be a pattern that is repeated in all widgets
export const ControlledToggleWidget = ({ name, helpText, ...props }: Omit<ToggleWidgetProps, 'onChange'>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const fieldValue = useWatch({
    control,
    name,
  });

  const error = getAt<FieldError>(errors, name);
  if (error) {
    helpText = (error.message as string) ?? 'Validation error';
  }

  const options = props.values.map(({ id, label }) => ({ label, value: id }));

  return (
    <div data-attribute={name} data-testid={name} data-value={fieldValue}>
      <div className={props.className}>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value, ...field } }) => {
            return (
              <ToggleWidget
                name={field.name}
                title={props.label}
                helpText={helpText}
                invalid={!!error}
                label={props.label}
                type={props.type}
                values={props.values}
                options={options}
                selected={
                  // FIXME: AAAAaargh - what is up with this input? What do you even use the label for?
                  options
                    ? [
                        options.find((option, idx) => option.value === value || props.values[idx].code === value) ?? {
                          label: '',
                          value: '',
                        },
                      ]
                    : []
                }
                mandatory={props.mandatory}
                onChange={(e: ToggleEntry) => {
                  onChange(e.value);
                }}
              />
            );
          }}
          rules={props.rules}
        />
      </div>
    </div>
  );
};
